module.exports = __webpack_public_path__ + "static/media/are_you_professional_hand.9e8a5c04.png";